module.exports = __webpack_public_path__ + "img/recovery-convert.e399fb43.svg";